export const timeKey = (data) => {
  if (!data[0]) {
    return "dateTime";
  } else if (data[0]?.hasOwnProperty("localDateTime")) {
    return "localDateTime";
  } else {
    return "dateTime";
  }
};
